import { render, staticRenderFns } from "./404.vue?vue&type=template&id=7241976e&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=7241976e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241976e",
  null
  
)

export default component.exports